export default "__VITE_ASSET__23f79d82__"